import { makeAutoObservable, reaction, runInAction, observable, action } from 'mobx';
import agent from '../../app/api/agent';
import { Karte, pokusKarte, KarteDrugihIgraca, getColorPokers } from '../../app/api/karte';
import { toInteger, isNil } from 'lodash-es';
import { toast, Bounce } from 'react-toastify';
import { RiseLoader } from 'react-spinners';
import { round } from 'lodash-es';
import { WinRateSvi, winRateBoard } from '@app/util/oddsCalc';
import html2canvas from 'html2canvas';

class PokerStore {
	sjedalo0 = 'UTG';
	sjedalo1 = '1';
	sjedalo2 = '2';
	sjedalo3 = '3';
	sjedalo4 = '4';
	sjedalo5 = 'CO';
	sjedalo6 = 'BTN';
	sjedalo7 = 'SB';
	sjedalo8 = 'BB';
	stolice = ['UTG', '-', '-', '-', '-', 'CO', 'BTN', 'SB', 'BB'];
	karteStol = null;
	loading = false;
	spilBoja = true;
	valueSlider = 180;
	valueSliderKarte = 1;
	sliderMax = 10000;
	sliderMIN = 1;
	fakeData = false;
	tableKarte = null;
	igrac1 = null;
	igrac2 = null;
	igrac3 = null;
	igrac4 = null;
	igrac5 = null;
	igrac6 = null;
	igrac7 = null;
	igrac8 = null;
	igrac9 = null;
	fakeDatoteka = 1;
	krug = 0;
	sveKarteIMG = [];
	statistikaSvihIgraca = [];
	igracTableSvi = [];
	igracTable;
	sliderMaxKarte = 180;
	najboljiIgrac = [];
	karteSend = [];
	status1 = false;
	status2 = false;
	initKarte = Karte;
	karteDrugihIgraca = KarteDrugihIgraca;
	filterDjeljenjeKarata = false;
	cardDeskFront = '33';
	fakeIgrac = 2;
	filterKarte = 1;
	filterKombinacijaKarata = true;
	analizaStatistika = false;
	pokus = pokusKarte;
	startTime = null;
	statistikaIgre = null;
	startChipovi = 20000;
	interval = 8;
	igracaZaStolom = 8;
	suitedSB_BB = true;
	svakaKartaBB = false;
	kalkulacije = false;

	marksSlider = [
		{
			value: this.sliderMIN,
			label: 'Min.',
		},
		{
			value: this.sliderMax,
			label: 'Max.',
		},
	];
	marksSliderKarte = [
		{
			value: this.sliderMIN,
			label: 'Min',
		},
		{
			value: this.sliderMaxKarte,
			label: 'Max',
		},
	];

	constructor() {
		makeAutoObservable(this, {
			karteStol: observable,
			karteStolFun: action,
			loading: observable,
			spilBoja: observable,
			pokus: observable,
			valueSlider: observable,
			openModal: observable,
			sveKarteIMG: observable,
			sveKarteIMGFun: action,
			krug: observable,
			igrac1: observable,
			igracTable: observable,
			sliderMaxKarte: observable,
			fakeData: observable,
			tableKarte: observable,
			sveKarte: observable,
			initKarte: observable,
			karteDrugihIgraca: observable,
			igraoBigBlind: observable,
			filterAnalize: observable,
			postaviBojuTabla: observable,
			filterKombinacijaKarata: observable,
			MP_MP1: observable,
			CO: observable,
			BTN_BB_SB: observable,
			vjerojatnostSvi: observable,
		});

		reaction(
			() => this.sveKarteIMG,
			sveKarteIMG => {
				runInAction(() => {
					console.log('%c ****** OPALI POKER  ******************', 'color:#60BFC1');
				});
			}
		);

		const filter1 = JSON.parse(localStorage.getItem('igram'));
		if (filter1 === null) {
			localStorage.setItem('igram', JSON.stringify(this.initKarte));
		}
		this.MP_MP1 = JSON.parse(localStorage.getItem('MP_MP1'));
		if (this.MP_MP1 === null) {
			localStorage.setItem('MP_MP1', JSON.stringify(this.initKarte));
		}
		this.CO = JSON.parse(localStorage.getItem('CO'));
		if (this.CO === null) {
			localStorage.setItem('CO', JSON.stringify(this.initKarte));
		}
		this.BTN_BB_SB = JSON.parse(localStorage.getItem('BTN_BB_SB'));
		if (this.BTN_BB_SB === null) {
			localStorage.setItem('BTN_BB_SB', JSON.stringify(this.initKarte));
		}
	}

	promjeniUlazneKarte = (karta, index) => {
		if (this.filterKarte === 0) {
			this.initKarte[index][1] = !karta[1];
			localStorage.setItem('initKarte', JSON.stringify(this.initKarte));
		}
		if (this.filterKarte === 1) {
			this.initKarte[index][1] = !karta[1];
			localStorage.setItem('igram', JSON.stringify(this.initKarte));
		}
		if (this.filterKarte === 2) {
			this.initKarte[index][1] = !karta[1];
			localStorage.setItem('MP_MP1', JSON.stringify(this.initKarte));
			this.MP_MP1 = JSON.parse(localStorage.getItem('MP_MP1'));
		}
		if (this.filterKarte === 3) {
			this.initKarte[index][1] = !karta[1];
			localStorage.setItem('CO', JSON.stringify(this.initKarte));
			this.CO = JSON.parse(localStorage.getItem('CO'));
		}
		if (this.filterKarte === 4) {
			this.initKarte[index][1] = !karta[1];
			localStorage.setItem('BTN_BB_SB', JSON.stringify(this.initKarte));
			this.BTN_BB_SB = JSON.parse(localStorage.getItem('BTN_BB_SB'));
		}
	};

	filterKarataSaKojimIgram = e => {
		let tempFilter = e.target.value;
		this.filterKarte = tempFilter;
		if (tempFilter === 0) {
			this.initKarte = this.initKarte.filter(karta => {
				karta[1] = false;
				return karta;
			});
		}
		if (tempFilter === 1) {
			const filter1 = JSON.parse(localStorage.getItem('igram'));
			this.initKarte = this.initKarte.filter((karta, index) => {
				karta[0] = filter1[index][0];
				karta[1] = filter1[index][1];
				return karta;
			});
		}
		if (tempFilter === 2) {
			const MP_MP1 = JSON.parse(localStorage.getItem('MP_MP1'));
			this.initKarte = this.initKarte.filter((karta, index) => {
				karta[0] = MP_MP1[index][0];
				karta[1] = MP_MP1[index][1];
				return karta;
			});
		}
		if (tempFilter === 3) {
			const CO = JSON.parse(localStorage.getItem('CO'));
			this.initKarte = this.initKarte.filter((karta, index) => {
				karta[0] = CO[index][0];
				karta[1] = CO[index][1];
				return karta;
			});
		}
		if (tempFilter === 4) {
			const BTNBBSB = JSON.parse(localStorage.getItem('BTN_BB_SB'));
			this.initKarte = this.initKarte.filter((karta, index) => {
				karta[0] = BTNBBSB[index][0];
				karta[1] = BTNBBSB[index][1];
				return karta;
			});
		}
	};

	ulazneKarteDrugihIgraca = (karta, index) => {
		this.karteDrugihIgraca[index][1] = !karta[1];
		localStorage.setItem('karteDrugihIgraca', JSON.stringify(this.karteDrugihIgraca));
	};

	odaberiFrontKartu = e => {
		this.cardDeskFront = e.target.value;
		if (this.cardDeskFront === '22') {
			this.spilBoja = true;
		}
		window.localStorage.setItem('cardDesk', JSON.stringify(this.cardDeskFront));
		this.cetverobojniSpil();
	};

	odaberFakeDatoteku = e => {
		this.fakeDatoteka = e.target.value;
		if (this.fakeDatoteka === 0) {
			var data = JSON.parse(localStorage.getItem('lokalnaFakeDatoteka'));
			this.valueSlider = data.length;
			this.lokalnaFakeDatoteka = data;
		}
		if (this.fakeDatoteka === 1) {
			this.valueSlider = 30;
			this.igracaZaStolom = 9;
		}
		if (this.fakeDatoteka === 2) {
			this.valueSlider = 30;
			this.igracaZaStolom = 8;
		}
		if (this.fakeDatoteka === 3 || this.fakeDatoteka === 4) {
			this.valueSlider = 10000;
		}
	};

	brojIgracaZaStolom = e => {
		this.igracaZaStolom = e.target.value;
		this.ucitajPodatke();
	};

	idiNaKrug = krug => {
		this.krug = krug;
		this.cetverobojniSpil();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	karteStolFun = kartePost => {
		this.karteStol = kartePost;
	};

	sveKarteIMGFun = sveKarteIMG => {
		this.sveKarteIMG = sveKarteIMG;
	};

	handleSlider = e => {
		this.valueSlider = e.target.value;
		this.fakeData = false;
	};

	toggleFlag = key => {
		this[key] = !this[key];
	};

	keyValue = (e, key) => {
		this[key] = e.target.value;
	};

	handleKarte = krug => {
		this.valueSliderKarte = krug;
		this.krug = krug - 1;
		this.cetverobojniSpil();
	};

	prijeKrug = async () => {
		if (this.krug > 0) {
			runInAction(() => {
				this.krug = this.krug - 1;
			});
		}
		this.cetverobojniSpil();
	};

	poslijeKrug = async () => {
		if (this.krug < this.sveKarteIMG.length - 1) {
			this.krug = this.krug + 1;
		}
		this.cetverobojniSpil();
	};

	defSjedalo = (sjedalo, igrac) => {
		if (sjedalo === 'BTN') {
			return 'igrac' + igrac + ' btn';
		}
		if (sjedalo === 'SB' || sjedalo === 'BB') {
			return 'igrac' + igrac + ' sbbb';
		}
		if (sjedalo === 'CO') {
			return 'igrac' + igrac + ' co';
		}
		return 'igrac' + igrac;
	};

	bojaPremiumKarte = karta => {
		var boja = null;
		if (karta === 'AA' || karta === 'KK') {
			boja = 'red';
		}
		if (karta === 'QQ') {
			boja = 'blue';
		}
		return boja;
	};

	postaviBojuTabla = (tableKarta, krug, poz) => {
		var boja = null;
		if (tableKarta === null) return '';
		if (tableKarta[krug] === null || tableKarta[krug] === undefined) return '';
		var karta = tableKarta[krug][poz];
		if (karta === null || karta === undefined) return '';

		let vrijednost = null;
		var analizaKarte = karta
			.split(',')
			.filter(value => {
				return value !== '';
			})
			.map(value => {
				return value.split('-')[1];
			})
			.filter((value, index) => {
				// console.log(value, index);
				if (index === 0) {
					vrijednost = value;
				}
				if (index > 0 && value === vrijednost) return null;
				return value;
			});

		// Uklanjanje null, aq, ak , najvisa vrijednosti
		let rukeIgraca = Object.entries(this.igracTableSvi[krug])
			.filter(([key, value]) => {
				// console.log('key, value= ', key, value);
				return key.startsWith('igrac');
			})
			.map(([key, value]) => {
				// console.log('key,value', key, value);
				return value;
			})
			.filter(value => value !== null) // izbaci null
			.filter(value => value !== 'ak-2' && value !== 'aq-1' && value.split('-')[0] !== 'najvisa')
			.map(v => {
				return v.split('-')[0];
			});

		let jedinstveniTipovi = [];
		for (let i = 0; i < rukeIgraca.length; i++) {
			const tip = rukeIgraca[i];
			if (!jedinstveniTipovi.includes(tip)) {
				jedinstveniTipovi.push(tip);
			}
		}

		const kljucevi = {};
		tableKarta[krug].forEach(item => {
			if (item === null) return;
			const elementi = item.split(',').filter(Boolean);
			elementi.forEach(el => {
				const kljuc = el.split('-')[0]; // Uzimamo dio prije "-"
				if (!kljucevi[kljuc]) {
					kljucevi[kljuc] = 0;
				}
				kljucevi[kljuc]++;
			});
		});
		// 1. Definiramo rang jačine ruku
		const snaga = ['skalaboja', 'poker', 'full', 'boja', 'skala', 'set', 'dvapara', 'par'];
		// 2. Filtriramo koje kombinacije se stvarno pojavljuju
		const igraciProcisceno = snaga.filter(k => jedinstveniTipovi.includes(k));
		// var donjiRed = igraciProcisceno[0];
		var gornjiRed = igraciProcisceno[1];

		// console.log('%c ******  	postaviBojuTabla  ******************', 'color:blue');
		// console.log('01 pozicija=', poz);
		// console.log('02 karta koju vrednujemo= ', karta);
		// console.log('02A kartaje u analizi?:   ', KartaJeUAnalizi);
		// console.log('02B provjeraKarte', provjeraKarte);
		// console.log('03', tableKarta && this.igracTableSvi[krug]);
		// console.log('04', tableKarta && tableKarta[krug]);
		// console.log('05 analizaKarte=', analizaKarte, analizaKarte.length);
		// console.log('06 jedinstveniTipovi=', jedinstveniTipovi);
		// console.log('07 Ruke svih igraca ', rukeIgraca, 'U igri ukupno Igraca=', rukeIgraca.length);
		// console.log('08 kljucevi= ', kljucevi);
		// console.log('09 igraci Procisceno=', igraciProcisceno);
		// console.log('10 gornjiRed=', gornjiRed);

		if (karta.includes('par')) {
			boja = `${'0px 15px 10px ' + getColorPokers(0)}`;
		}
		if (karta.includes('dvapara')) {
			boja = `${'0px 15px 10px ' + getColorPokers(1)}`;
		}
		if (karta.includes('set')) {
			boja = `${'0px 15px 10px ' + getColorPokers(2)}`;
		}
		if (karta.includes('skala')) {
			boja = `${'0px 15px 10px ' + getColorPokers(3)}`;
		}
		if (karta.includes('boja')) {
			boja = `${'0px 15px 10px ' + getColorPokers(4)}`;
		}
		if (karta.includes('full')) {
			boja = `${'0px 15px 10px ' + getColorPokers(5)}`;
		}
		if (karta.includes('poker')) {
			boja = `${'0px 15px 10px ' + getColorPokers(6)}`;
		}
		if (igraciProcisceno.length > 1) {
			if (gornjiRed === 'par' && karta.includes(gornjiRed) && igraciProcisceno.length > 1 && analizaKarte.length > 1) {
				if (boja === `${'0px 15px 10px ' + getColorPokers(0)}`) {
					boja = `${'0px -15px 10px ' + getColorPokers(0)}`;
				} else {
					boja = boja + `${',0px -15px 10px ' + getColorPokers(0)}`;
				}
			}
			if (
				gornjiRed === 'dvapara' &&
				karta.includes(gornjiRed) &&
				igraciProcisceno.length > 1 &&
				analizaKarte.length > 1
			) {
				if (boja === `${'0px 15px 10px ' + getColorPokers(1)}`) {
					boja = `${'0px -15px 10px ' + getColorPokers(1)}`;
				} else {
					boja = boja + `${',0px -15px 10px ' + getColorPokers(1)}`;
				}
			}
			if (gornjiRed === 'set' && karta.includes(gornjiRed) && igraciProcisceno.length > 1 && analizaKarte.length > 1) {
				if (boja === `${'0px 15px 10px ' + getColorPokers(2)}`) {
					boja = `${'0px -15px 10px ' + getColorPokers(2)}`;
				} else {
					boja = boja + `${',0px -15px 10px ' + getColorPokers(2)}`;
				}
			}
			if (gornjiRed === 'boja' && karta.includes(gornjiRed) && igraciProcisceno.length > 1 && analizaKarte.length > 1) {
				if (boja === `${'0px 15px 10px ' + getColorPokers(4)}`) {
					boja = `${'0px -15px 10px ' + getColorPokers(4)}`;
				} else {
					boja = boja + `${',0px -15px 10px ' + getColorPokers(4)}`;
				}
			}
			if (gornjiRed === 'full' && karta.includes(gornjiRed) && igraciProcisceno.length > 1 && analizaKarte.length > 1) {
				if (boja === `${'0px 15px 10px ' + getColorPokers(5)}`) {
					boja = `${'0px -15px 10px ' + getColorPokers(5)}`;
				} else {
					boja = boja + `${',0px 15px 10px ' + getColorPokers(5)}`;
				}
			}
		}
		return boja;
	};

	postaviBojuIgrac = (tableKarta, fullKartaOznaka, krug) => {
		var boja = null;
		var kartaTrazim = null;
		var karta = fullKartaOznaka[0];
		if (tableKarta === null || karta === null) return '';

		// console.log('%c ******  	postaviBojuIgrac  ******************', 'color:gold');
		// console.log('01 ***** tableKarta =', tableKarta);
		// console.log('02 ***** fullKartaOznaka =', fullKartaOznaka);
		// console.log('03 ***** Karta=', karta);

		if (!tableKarta.includes('boja')) {
			for (let i = 0; i < 5; i++) {
				var poz = this.igracaZaStolom * 2 + i;
				// console.log(this.sveKarte[krug][poz]);
				if (karta === this.sveKarte[krug][poz][0]) {
					kartaTrazim = karta;
				}
			}
		} else {
			var bojaKarte = fullKartaOznaka[1];
			// console.log('kada imamo boju...bojaKarte=', bojaKarte);
			var bojaKojaJeNaStolu = tableKarta.split('-')[2];
			// console.log('kada imamo boju...bojaKojaJeNaStolu=', bojaKojaJeNaStolu);
			if (bojaKojaJeNaStolu === bojaKarte) {
				kartaTrazim = tableKarta.split('-')[1];
			}
		}

		if (tableKarta.includes('par') && kartaTrazim === null && tableKarta.length === 5) {
			kartaTrazim = tableKarta.split('-')[1]; // par je u ruci npr 77   "par-7"
		}
		if (tableKarta.includes('dvapara') && kartaTrazim === null) {
			if (karta === tableKarta.split('-')[1]) {
				kartaTrazim = tableKarta.split('-')[1];
			}
			if (karta === tableKarta.split('-')[2]) {
				kartaTrazim = tableKarta.split('-')[2];
			}
		}

		if (kartaTrazim === null) return '';
		if (tableKarta.includes('par')) {
			boja = `${'0px 15px 10px ' + getColorPokers(0)}`;
		}
		if (tableKarta.includes('dvapara')) {
			boja = `${'0px 15px 10px ' + getColorPokers(1)}`;
		}
		if (tableKarta.includes('set')) {
			boja = `${'0px 15px 10px ' + getColorPokers(2)}`;
		}
		if (tableKarta.includes('skala')) {
			boja = `${'0px 15px 10px ' + getColorPokers(3)}`;
		}
		if (tableKarta.includes('boja')) {
			boja = `${'0px 15px 10px ' + getColorPokers(4)}`;
		}
		if (tableKarta.includes('full')) {
			boja = `${'0px 15px 10px ' + getColorPokers(5)}`;
		}
		if (tableKarta.includes('poker')) {
			boja = `${'0px 15px 10px ' + getColorPokers(6)}`;
		}
		return boja;
	};

	osjencajNeaktivnuKartu = (dobitak, igrac) => {
		if (dobitak !== null || igrac === this.odabraniIgrac) return 1;
		return 0.4;
	};

	fakeDataSwitch = () => {
		this.fakeData = !this.fakeData;
		if (this.fakeData === true && (this.fakeDatoteka === 1 || this.fakeDatoteka === 3)) {
			this.valueSlider = 30;
		} else {
			this.valueSlider = 180;
			this.fakeDatoteka = 1;
		}
		window.localStorage.setItem('fakeData', JSON.stringify(this.fakeData));
	};

	handleScreenshot = async captureRef => {
		if (!captureRef || !captureRef.current) return;
		// Scroll element u vidokrug
		captureRef.current.scrollIntoView({ behavior: 'auto' });
		// Renderuj element u canvas
		const fullCanvas = await html2canvas(captureRef.current, {
			backgroundColor: null,
			useCORS: true,
		});
		// Dimenzije originalnog canvasa (elementa)
		const fullWidth = fullCanvas.width;
		const fullHeight = fullCanvas.height;
		// Odredi dimenzije (gornji lijevi dio)
		const cropWidth = fullWidth * 0.4;
		const cropHeight = fullHeight * 0.45;
		// Napravi novi canvas za isječak
		const croppedCanvas = document.createElement('canvas');
		croppedCanvas.width = cropWidth;
		croppedCanvas.height = cropHeight;
		const ctx = croppedCanvas.getContext('2d');
		// Izreži gornju lijevu četvrtinu
		ctx.drawImage(
			fullCanvas,
			0,
			130, // početna točka iz full canvasa
			cropWidth,
			cropHeight, // veličina isječka
			0,
			0, // gdje da zalijepi u novi canvas
			cropWidth,
			cropHeight
		);
		// Pretvori isječak u sliku
		const image = croppedCanvas.toDataURL('image/png');
		// Preuzmi sliku
		const link = document.createElement('a');
		link.href = image;
		link.download = 'A001.png';
		link.click();
	};

	cetverobojniSpil = promjenaBoje => {
		try {
			if (promjenaBoje === 'Da') {
				this.toggleFlag('spilBoja');
			}
			this.postaviBB();
			if (this.cardDeskFront === '11') {
				this.sveKarteIMG[this.krug] = this.sveKarteIMG[this.krug].map(karta => karta.replace(/22|33|44|55/, '11'));
			}
			if (this.cardDeskFront === '22') {
				this.sveKarteIMG[this.krug] = this.sveKarteIMG[this.krug].map(karta => karta.replace(/11|33|44|55/, '22'));
			}
			if (this.cardDeskFront === '33') {
				this.sveKarteIMG[this.krug] = this.sveKarteIMG[this.krug].map(karta => karta.replace(/11|22|44|55/, '33'));
			}
			if (this.cardDeskFront === '44') {
				this.sveKarteIMG[this.krug] = this.sveKarteIMG[this.krug].map(karta => karta.replace(/11|22|33|55/, '44'));
			}
			if (this.cardDeskFront === '55') {
				this.sveKarteIMG[this.krug] = this.sveKarteIMG[this.krug].map(karta => karta.replace(/11|22|33|44/, '55'));
			}
			let noveKarte = this.sveKarteIMG[this.krug];
			if (this.spilBoja === true) {
				runInAction(() => {
					noveKarte = noveKarte.map(karta => karta.replace('D', 'P'));
					noveKarte = noveKarte.map(karta => karta.replace('C', 'Z'));
					this.sveKarteIMG[this.krug] = noveKarte;
				});
			} else {
				runInAction(() => {
					noveKarte = noveKarte.map(karta => karta.replace('P', 'D'));
					noveKarte = noveKarte.map(karta => karta.replace('Z', 'C'));
					this.sveKarteIMG[this.krug] = noveKarte;
				});
			}
			const flop = [
				this.sveKarte[this.krug][this.igracaZaStolom * 2],
				this.sveKarte[this.krug][this.igracaZaStolom * 2 + 1],
				this.sveKarte[this.krug][this.igracaZaStolom * 2 + 2],
			];
			const turn = [this.sveKarte[this.krug][this.igracaZaStolom * 2 + 3]];
			this.vjerojatnostSvi = WinRateSvi(this.sveKarte[this.krug], this.igracaZaStolom);
			this.vjerojatnostUcesnika = winRateBoard(
				this.sveKarte[this.krug],
				this.igracaZaStolom,
				this.igracTableSvi[this.krug]
			);
			this.vjerojatnostUcesnikaFlop = winRateBoard(
				this.sveKarte[this.krug],
				this.igracaZaStolom,
				this.igracTableSvi[this.krug],
				flop
			);
			this.vjerojatnostUcesnikaTurn = winRateBoard(
				this.sveKarte[this.krug],
				this.igracaZaStolom,
				this.igracTableSvi[this.krug],
				flop,
				turn
			);
		} catch (err) {
			toast.error('Nesto nije u redu u cetverobojniSpil!', err);
		}
	};

	igraoKrugBoja = krug => {
		var tempStyle = '';
		var x = this.pobjedeOdabranog.findIndex(item => item === parseInt(krug.split('-')[0]));
		if (x !== -1) {
			tempStyle = 'teal';
		} else {
			tempStyle = '#858585';
		}
		return tempStyle;
	};

	defBojuTextaBTN = sjedalo => {
		if (sjedalo === 'BTN' || sjedalo === 'SB' || sjedalo === 'BB' || sjedalo === 'CO') {
			return '';
		}
		return 'white';
	};

	definirajText = (textNadKartom, sjedalo) => {
		if (textNadKartom !== null) {
			if (textNadKartom.includes('par-')) {
				return textNadKartom.slice(0, 7);
			}
			if (textNadKartom.includes('dvapara')) {
				return textNadKartom.slice(0, 13);
			}
			if (textNadKartom.includes('set')) {
				return textNadKartom.slice(0, 7);
			}
			if (textNadKartom.includes('skalaboja')) {
				toast.success('♦️♥️♣️♠️ Skala u boji!', {
					position: 'top-right',
					autoClose: 4000,
					hideProgressBar: false,
					closeOnClick: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: 'light',
					transition: Bounce,
				});
				return <div>Skala boja!</div>;
			}
			if (textNadKartom.includes('poker')) {
				toast.success('♦️♥️♣️♠️ Poker!', {
					position: 'top-right',
					autoClose: 4000,
					hideProgressBar: false,
					closeOnClick: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: 'light',
					transition: Bounce,
				});
				return <div>P O K E R!</div>;
			}
			if (textNadKartom.includes('boja')) {
				return textNadKartom.slice(0, 6);
			}
			if (textNadKartom.includes('skala')) {
				return textNadKartom.slice(0, 7);
			}
			if (textNadKartom.includes('full')) {
				return textNadKartom.slice(0, 8);
			}
			if (textNadKartom.includes('najvisa')) {
				return <RiseLoader color="white" margin={5} size={15} />;
			}
			return textNadKartom;
		}
		if (sjedalo === 'BTN' || sjedalo === 'SB' || sjedalo === 'BB' || sjedalo === 'CO') {
			return sjedalo;
		}
		return '-'; // nema nikakav text iznad karte
	};

	ucitajPodatke = async () => {
		try {
			this.startTime = performance.now();
			this.loading = true;
			if (this.fakeData === true) {
				this.odabraniIgrac = this.fakeIgrac;
			} else {
				if (this.igracaZaStolom === 9) {
					this.odabraniIgrac = Math.floor(Math.random() * 9);
				} else {
					this.odabraniIgrac = Math.floor(Math.random() * 8);
				}
			}
			this.UTG_UTG1_UTG2 = this.initKarte
				.filter(card => {
					if (card[1] === false) return card[0]; // Provjeri da je selected definiran
					return false;
				})
				.map(card => {
					return card[0];
				})
				.join(' '); // Spoji sve karte u jedan string

			this.MP_MP1_send = this.MP_MP1.filter(card => {
				if (card[1] === false) return card[0]; // Provjeri da je selected definiran
				return false;
			})
				.map(card => {
					return card[0];
				})
				.join(' '); // Spoji sve karte u jedan string

			this.CO_send = this.CO.filter(card => {
				if (card[1] === false) return card[0]; // Provjeri da je selected definiran
				return false;
			})
				.map(card => {
					return card[0];
				})
				.join(' '); // Spoji sve karte u jedan string

			this.BTN_BB_SB_send = this.BTN_BB_SB.filter(card => {
				if (card[1] === false) return card[0]; // Provjeri da je selected definiran
				return false;
			})
				.map(card => {
					return card[0];
				})
				.join(' '); // Spoji sve karte u jedan string

			const karteDrugihIgraca = this.karteDrugihIgraca
				.filter(card => {
					if (card[1] === false) return card[0]; // Provjeri da je selected definiran
					return false;
				})
				.map(card => {
					return card[0];
				})
				.join(' '); // Spoji sve karte u jedan string

			const kartePost = await agent.Poker.podjeliKarte({
				brojDjeljenja: this.valueSlider,
				fakeData: this.fakeData,
				fakeDatotaka: this.fakeDatoteka,
				UTG_UTG1_UTG2: this.UTG_UTG1_UTG2,
				pokus: this.pokus,
				odabraniIgrac: this.fakeData ? this.fakeIgrac : this.odabraniIgrac,
				karteDrugihIgraca: karteDrugihIgraca,
				MP_MP1: this.MP_MP1_send,
				CO: this.CO_send,
				BTN_SB_BB: this.BTN_BB_SB_send,
				lokalnaFakeDatoteka: this.lokalnaFakeDatoteka,
				startChipovi: this.startChipovi,
				interval: this.interval,
				IgracaZaStolom: this.igracaZaStolom,
				suitedSB_BB: this.suitedSB_BB,
				svakaKartaBB: this.svakaKartaBB,
				kalkulacije: this.kalkulacije,
			});
			runInAction(() => {
				const endTime = performance.now(); // kraj mjerenja vremena
				console.log(`Response time BACKEND: ${(endTime - this.startTime).toFixed(2)} ms`);
				this.startTime = performance.now(); // Frontend
				this.sliderMaxKarte = this.valueSlider;
				console.log('%c ******** 001 Glavni podaci ***************', 'color:red', kartePost);
				this.karteStolFun(kartePost);
				let {
					sveKarteIMG,
					statistikaSvihIgraca,
					igracTable,
					igracTableSvi,
					tableKarte,
					prazniKrugovi,
					najboljiIgrac,
					pobjednik,
					bojaViseCetri,
					pobjedeOdabranog,
					krugSet,
					krugFull,
					sveKarte,
					igraoKrug,
					viseSetovaPoKruguIgraci,
					igraoBigBlind,
					igraoCO,
					premiumAllInKarta,
					imaoNizeParoveNiz,
					igraosvakuKartuSaAsom,
					ostaloChipova,
					postotakDobitakaNizihParova,
					postotakNiziParovaSet,
					postotakPobjedeOdabranogIgraca,
					igraciKartePostoak,
					karteIgracaKrug,
					sveSuitedKarteOdabranog,
					krugAQ,
				} = this.karteStol;
				this.krugAQ = krugAQ;
				this.prazniKrugovi = prazniKrugovi;
				this.statistikaSvihIgraca = statistikaSvihIgraca;
				this.igracTable = igracTable;
				this.igracTableSvi = igracTableSvi;
				this.tableKarte = tableKarte;
				this.najboljiIgrac = najboljiIgrac;
				this.pobjednik = pobjednik;
				this.bojaViseCetri = bojaViseCetri;
				this.pobjedeOdabranog = pobjedeOdabranog;
				this.krugSet = krugSet;
				this.krugFull = krugFull;
				this.sveKarte = sveKarte;
				this.igraoKrug = igraoKrug;
				this.igraoBigBlind = igraoBigBlind;
				this.igraoCO = igraoCO;
				this.viseSetovaPoKruguIgraci = viseSetovaPoKruguIgraci;
				this.premiumAllInKarta = premiumAllInKarta;
				this.imaoNizeParoveNiz = imaoNizeParoveNiz;
				this.igraosvakuKartuSaAsom = igraosvakuKartuSaAsom;
				this.ostaloChipova = ostaloChipova;
				this.postotakDobitakaNizihParova = postotakDobitakaNizihParova;
				this.postotakNiziParovaSet = postotakNiziParovaSet;
				this.postotakPobjedeOdabranogIgraca = postotakPobjedeOdabranogIgraca;
				this.igraciKartePostoak = igraciKartePostoak;
				this.karteIgracaKrug = karteIgracaKrug;
				this.sveSuitedKarteOdabranog = sveSuitedKarteOdabranog;
				this.sveKarteIMGFun(sveKarteIMG);
				this.cetverobojniSpil();
				localStorage.setItem('lokalnaFakeDatoteka', JSON.stringify(this.sveKarte));
				this.integerIgraoKrug = this.igraoKrug.map(data => {
					return parseInt(data.split('-')[0]);
				});

				var tempIgrao = this.statistikaSvihIgraca.filter(data => {
					if (parseInt(data.name) === this.odabraniIgrac) {
						return data;
					} else return null;
				});
				var tempPobjedniik = this.pobjednik.filter(data => {
					if (parseInt(data.igrac) === this.odabraniIgrac) {
						return data;
					} else return null;
				});

				var localStorageData =
					'Igrac-' +
					this.odabraniIgrac +
					': ' +
					' In:  ' +
					round((tempIgrao[0].ulazakIgra / this.valueSlider) * 100, 0).toString() +
					'% ' +
					tempIgrao[0].ulazakIgra +
					' ruku   Σ-  ' +
					round((tempIgrao[0].suma / this.valueSlider) * 100, 0).toString() +
					'% - Win: ' +
					round((tempPobjedniik[0]?.count / this.valueSlider) * 100, 1).toString() +
					'% - pobjede: ' +
					this.postotakPobjedeOdabranogIgraca +
					' %';
				// 1. Dohvati postojeće podatke
				let podaci = localStorage.getItem('analizaStatistika');
				// 2. Parsiraj ako postoji, inače napravi novi niz
				var niz = podaci ? JSON.parse(podaci) : [];
				// 3. Dodaj novi zapis na pocetak
				niz.unshift(localStorageData);
				// 4. Zadrži prvih 5
				this.analizaStatistikaStorage = niz.slice(0, 8);
				// 5. Spremi natrag u localStorage
				localStorage.setItem('analizaStatistika', JSON.stringify(this.analizaStatistikaStorage));
			});
		} catch (err) {
			toast.error('Nesto nije u redu u ucitajPodatke!', err);
		} finally {
			runInAction(() => {
				const endTime = performance.now(); // kraj mjerenja vremena za frontend
				console.log(`Response time FRONT: ${(endTime - this.startTime).toFixed(2)} ms`);
				this.loading = false;
				toast.success(
					`Prazni krugovi:${this.prazniKrugovi} -> ${round((this.prazniKrugovi / this.valueSlider) * 100, 0)}%`,
					{
						position: 'top-center',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: 'light',
						transition: Bounce,
					}
				);
			});
		}
	};

	igraoKrugProvjera = krug => {
		if (krug === null || isNil(this.igraoKrug)) return false;
		if (this.integerIgraoKrug.includes(krug) === true) {
			return true;
		} else {
			return false;
		}
	};

	podjeliKarte = async () => {
		try {
			this.krug = 0;
			this.karteIMG = null;
			this.karte = null;
			this.ucitajPodatke();
		} catch (err) {
			toast.error('Nesto nije u redu sa učitavanjem!', err);
		}
	};

	postaviBB = () => {
		const BBSjedalo = this.krug - toInteger(this.krug / this.igracaZaStolom) * this.igracaZaStolom;
		if (this.igracaZaStolom === 9) {
			if (BBSjedalo === 0) {
				this.sjedalo0 = this.stolice[0];
				this.sjedalo1 = this.stolice[1];
				this.sjedalo2 = this.stolice[2];
				this.sjedalo3 = this.stolice[3];
				this.sjedalo4 = this.stolice[4];
				this.sjedalo5 = this.stolice[5];
				this.sjedalo6 = this.stolice[6];
				this.sjedalo7 = this.stolice[7];
				this.sjedalo8 = this.stolice[8];
			}
			if (BBSjedalo === 1) {
				this.sjedalo0 = this.stolice[8];
				this.sjedalo1 = this.stolice[0];
				this.sjedalo2 = this.stolice[1];
				this.sjedalo3 = this.stolice[2];
				this.sjedalo4 = this.stolice[3];
				this.sjedalo5 = this.stolice[4];
				this.sjedalo6 = this.stolice[5];
				this.sjedalo7 = this.stolice[6];
				this.sjedalo8 = this.stolice[7];
			}
			if (BBSjedalo === 2) {
				this.sjedalo0 = this.stolice[7];
				this.sjedalo1 = this.stolice[8];
				this.sjedalo2 = this.stolice[0];
				this.sjedalo3 = this.stolice[1];
				this.sjedalo4 = this.stolice[2];
				this.sjedalo5 = this.stolice[3];
				this.sjedalo6 = this.stolice[4];
				this.sjedalo7 = this.stolice[5];
				this.sjedalo8 = this.stolice[6];
			}
			if (BBSjedalo === 3) {
				this.sjedalo0 = this.stolice[6];
				this.sjedalo1 = this.stolice[7];
				this.sjedalo2 = this.stolice[8];
				this.sjedalo3 = this.stolice[0];
				this.sjedalo4 = this.stolice[1];
				this.sjedalo5 = this.stolice[2];
				this.sjedalo6 = this.stolice[3];
				this.sjedalo7 = this.stolice[4];
				this.sjedalo8 = this.stolice[5];
			}
			if (BBSjedalo === 4) {
				this.sjedalo0 = this.stolice[5];
				this.sjedalo1 = this.stolice[6];
				this.sjedalo2 = this.stolice[7];
				this.sjedalo3 = this.stolice[8];
				this.sjedalo4 = this.stolice[0];
				this.sjedalo5 = this.stolice[1];
				this.sjedalo6 = this.stolice[2];
				this.sjedalo7 = this.stolice[3];
				this.sjedalo8 = this.stolice[4];
			}
			if (BBSjedalo === 5) {
				this.sjedalo0 = this.stolice[4];
				this.sjedalo1 = this.stolice[5];
				this.sjedalo2 = this.stolice[6];
				this.sjedalo3 = this.stolice[7];
				this.sjedalo4 = this.stolice[8];
				this.sjedalo5 = this.stolice[0];
				this.sjedalo6 = this.stolice[1];
				this.sjedalo7 = this.stolice[2];
				this.sjedalo8 = this.stolice[3];
			}
			if (BBSjedalo === 6) {
				this.sjedalo0 = this.stolice[3];
				this.sjedalo1 = this.stolice[4];
				this.sjedalo2 = this.stolice[5];
				this.sjedalo3 = this.stolice[6];
				this.sjedalo4 = this.stolice[7];
				this.sjedalo5 = this.stolice[8];
				this.sjedalo6 = this.stolice[0];
				this.sjedalo7 = this.stolice[1];
				this.sjedalo8 = this.stolice[2];
			}
			if (BBSjedalo === 7) {
				this.sjedalo0 = this.stolice[2];
				this.sjedalo1 = this.stolice[3];
				this.sjedalo2 = this.stolice[4];
				this.sjedalo3 = this.stolice[5];
				this.sjedalo4 = this.stolice[6];
				this.sjedalo5 = this.stolice[7];
				this.sjedalo6 = this.stolice[8];
				this.sjedalo7 = this.stolice[0];
				this.sjedalo8 = this.stolice[1];
			}
			if (BBSjedalo === 8) {
				this.sjedalo0 = this.stolice[1];
				this.sjedalo1 = this.stolice[2];
				this.sjedalo2 = this.stolice[3];
				this.sjedalo3 = this.stolice[4];
				this.sjedalo4 = this.stolice[5];
				this.sjedalo5 = this.stolice[6];
				this.sjedalo6 = this.stolice[7];
				this.sjedalo7 = this.stolice[8];
				this.sjedalo8 = this.stolice[0];
			}
		}

		if (this.igracaZaStolom === 8) {
			if (BBSjedalo === 0) {
				this.sjedalo0 = this.stolice[0];
				this.sjedalo1 = this.stolice[1];
				this.sjedalo2 = this.stolice[3];
				this.sjedalo3 = this.stolice[4];
				this.sjedalo4 = this.stolice[5];
				this.sjedalo5 = this.stolice[6];
				this.sjedalo6 = this.stolice[7];
				this.sjedalo7 = this.stolice[8];
			}
			if (BBSjedalo === 1) {
				this.sjedalo0 = this.stolice[8];
				this.sjedalo1 = this.stolice[0];
				this.sjedalo2 = this.stolice[1];
				this.sjedalo3 = this.stolice[3];
				this.sjedalo4 = this.stolice[4];
				this.sjedalo5 = this.stolice[5];
				this.sjedalo6 = this.stolice[6];
				this.sjedalo7 = this.stolice[7];
			}
			if (BBSjedalo === 2) {
				this.sjedalo0 = this.stolice[7];
				this.sjedalo1 = this.stolice[8];
				this.sjedalo2 = this.stolice[0];
				this.sjedalo3 = this.stolice[1];
				this.sjedalo4 = this.stolice[3];
				this.sjedalo5 = this.stolice[4];
				this.sjedalo6 = this.stolice[5];
				this.sjedalo7 = this.stolice[6];
			}
			if (BBSjedalo === 3) {
				this.sjedalo0 = this.stolice[6];
				this.sjedalo1 = this.stolice[7];
				this.sjedalo2 = this.stolice[8];
				this.sjedalo3 = this.stolice[0];
				this.sjedalo4 = this.stolice[1];
				this.sjedalo5 = this.stolice[3];
				this.sjedalo6 = this.stolice[4];
				this.sjedalo7 = this.stolice[5];
			}
			if (BBSjedalo === 4) {
				this.sjedalo0 = this.stolice[5];
				this.sjedalo1 = this.stolice[6];
				this.sjedalo2 = this.stolice[7];
				this.sjedalo3 = this.stolice[8];
				this.sjedalo4 = this.stolice[0];
				this.sjedalo5 = this.stolice[1];
				this.sjedalo6 = this.stolice[3];
				this.sjedalo7 = this.stolice[4];
			}
			if (BBSjedalo === 5) {
				this.sjedalo0 = this.stolice[4];
				this.sjedalo1 = this.stolice[5];
				this.sjedalo2 = this.stolice[6];
				this.sjedalo3 = this.stolice[7];
				this.sjedalo4 = this.stolice[8];
				this.sjedalo5 = this.stolice[0];
				this.sjedalo6 = this.stolice[1];
				this.sjedalo7 = this.stolice[3];
			}
			if (BBSjedalo === 6) {
				this.sjedalo0 = this.stolice[3];
				this.sjedalo1 = this.stolice[4];
				this.sjedalo2 = this.stolice[5];
				this.sjedalo3 = this.stolice[6];
				this.sjedalo4 = this.stolice[7];
				this.sjedalo5 = this.stolice[8];
				this.sjedalo6 = this.stolice[0];
				this.sjedalo7 = this.stolice[1];
			}
			if (BBSjedalo === 7) {
				this.sjedalo0 = this.stolice[1];
				this.sjedalo1 = this.stolice[3];
				this.sjedalo2 = this.stolice[4];
				this.sjedalo3 = this.stolice[5];
				this.sjedalo4 = this.stolice[6];
				this.sjedalo5 = this.stolice[7];
				this.sjedalo6 = this.stolice[8];
				this.sjedalo7 = this.stolice[0];
			}
		}
	};
}

export default PokerStore;
